<template>
  <v-form-create name="tech_map" top_title="tech_map_detail" large>
    <v-form v-model="is_valid">
      <v-autocomplete
        v-model="tech_map.product_id"
        :label="$t('item')"
        hide-no-data
        v-bind:items="items_list"
        item-text="search_text"
        item-value="product_id"
        :rules="[fieldRules.required]"
        ref="product_id"
        v-on:update:search-input="getItems"
      >
        <template #item="data">
          <v-list-item-content>
            <v-list-item-title>{{ data.item.product_name }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ data.item.category_name }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>SKU {{ data.item.sku }}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
        <template #selection="data">
          {{ data.item.product_name }}
        </template>
      </v-autocomplete>

      <v-data-table
        :mobile-breakpoint="0"
        v-bind:headers="headers"
        v-bind:items="tech_map.composite_items"
        :items-per-page="100"
        hide-default-footer
        disable-sort
      >
        <template #[`item.remove`]="{ item }">
          <v-btn icon @click="removeItem(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>

        <template #[`item.quality`]="{ item }">
          <v-text-field
            v-model="item.quality"
            reverse
            @focus="$event.target.select()"
            autocomplete="off"
          />
        </template>

        <template #[`item.cost`]="{ item }">
          {{ item.cost.toLocaleString() }}
        </template>
        <template #[`item.total_cost`]="{ item }">
          {{ (item.cost * item.quality).toLocaleString() }}
        </template>
      </v-data-table>
      <v-card-text>
        <v-autocomplete
          v-model="composite_item"
          :label="$t('add_item')"
          hide-no-data
          :loading="searching_composite_items"
          v-bind:items="composite_items_list"
          item-text="search_text"
          return-object
          v-on:update:search-input="getCompositeItems"
          v-on:change="addItem"
        >
          <template #item="data">
            <v-list-item-content>
              <v-list-item-title>{{
                data.item.product_name
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                data.item.category_name
              }}</v-list-item-subtitle>
              <v-list-item-subtitle
                >SKU {{ data.item.sku }}</v-list-item-subtitle
              >
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-card-text>
      <v-divider></v-divider>
      <v-layout row px-5 mt-5>
        <v-spacer />
        <p class="body-1 black--text font-weight-bold ">
          {{ $t("total") }}:
          {{ total_cost }}
        </p>
      </v-layout>
      <v-divider></v-divider>
    </v-form>
    <template #action>
      <v-btn text @click="goBack">{{ $t("cancel") }}</v-btn>
      <v-btn text color="primary" v-on:click="save" :disabled="saveDisabled">
        {{ $t(target) }}
      </v-btn>
    </template>
  </v-form-create>
</template>

<script>
import TechMap from "../../mixins/items/tech_map";

export default {
  data: () => ({
    is_valid: false,
    search_composite_item_text: "123",
    search_item_text: "123",
    items_list: [],
    composite_items_list: [],
    searching_composite_items: false,
    composite_item: null,
    is_composite_item: false,
    last_composite_item: false
  }),
  mixins: [TechMap],
  computed: {
    target() {
      return this.$route.params.target;
    },
    saveDisabled() {
      let formHasErrors = false || !this.is_valid;
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
    form() {
      return {
        product_id: this.tech_map.product_id
      };
    },
    headers() {
      return [
        { text: this.$t("item"), value: "product_name" },
        {
          text: this.$t("quality"),
          value: "quality",
          align: "right",
          width: 100
        },
        {
          text: this.$t("cost"),
          value: "cost",
          align: "right",
          width: 100
        },
        {
          text: this.$t("total_cost"),
          value: "total_cost",
          align: "right",
          width: 100
        },
        { text: null, value: "remove", align: "right", width: 60 }
      ];
    },
    tech_map_id() {
      return this.$route.query.id;
    },
    total_cost() {
      let total_cost = 0;
      for (const it of this.tech_map.composite_items) {
        total_cost += it.quality * it.cost;
      }
      return total_cost ? total_cost.toLocaleString() : total_cost;
    }
  },
  methods: {
    async createTechMap() {
      return this.$communicator.then(
        this,
        await this.$communicator("tech_map_create", {
          params: this.tech_map
        })
      );
    },
    async updateTechMap() {
      return this.$communicator.then(
        this,
        await this.$communicator("tech_map_update", {
          params: this.tech_map
        })
      );
    },

    async save() {
      let result;
      if (this.target == "create") {
        result = await this.createTechMap();
      } else {
        result = await this.updateTechMap();
      }
      if (result) {
        this.$router.push("/items/tech-map").catch(() => {});
      }
    },

    async getItems(search) {
      if (typeof search !== "string") {
        search = "";
      }
      if (this.search_item_text == search) {
        return;
      }

      this.last_composite_item = this.is_composite_item;

      this.search_item_text = search;
      const res = this.$communicator.then(
        this,
        await this.$communicator("list_of_items", {
          arguments: [50, 1],
          params: {
            name: search,
            composite_item: false
          }
        })
      );

      if (res && res.data) {
        const items = res.data;
        var items_list = [];
        for (const index in items) {
          if (
            this.target == "create" ||
            (this.target == "update" &&
              this.$route.query["id"] !== items[index]._id)
          ) {
            let search_text =
              items[index].name + items[index].category_name + items[index].sku;
            if (typeof items[index].barcode == typeof []) {
              for (const b of items[index].barcode) {
                search_text += b;
              }
            }
            items_list.push({
              product_id: items[index]._id,
              product_name: items[index].name,
              cost: items[index].cost,
              sku: items[index].sku,
              cost_currency: items[index].cost_currency,
              quality: 1,
              search_text: search_text
            });
          }
        }

        this.items_list = items_list;
      }
    },

    async getCompositeItems(search) {
      if (typeof search !== "string") {
        search = "";
      }
      if (this.search_composite_item_text == search) {
        return;
      }

      this.last_composite_item = this.is_composite_item;

      this.search_composite_item_text = search;
      this.searching_composite_items = true;
      const res = this.$communicator.then(
        this,
        await this.$communicator("list_of_items", {
          arguments: [50, 1],
          params: {
            name: search,
            composite_item: true
          }
        })
      );

      if (res && res.data) {
        const items = res.data;
        var items_list = [];
        for (const index in items) {
          if (
            this.target == "create" ||
            (this.target == "update" &&
              this.$route.query["id"] !== items[index]._id)
          ) {
            let search_text =
              items[index].name + items[index].category_name + items[index].sku;
            if (typeof items[index].barcode == typeof []) {
              for (const b of items[index].barcode) {
                search_text += b;
              }
            }
            items_list.push({
              product_id: items[index]._id,
              product_name: items[index].name,
              cost: items[index].cost,
              sku: items[index].sku,
              cost_currency: items[index].cost_currency,
              quality: 1,
              search_text: search_text
            });
          }
        }

        this.composite_items_list = items_list;
      }

      this.searching_composite_items = false;
    },

    addItem() {
      if (!this.composite_item) {
        return;
      }
      let exist = false;
      for (const itm of this.tech_map.composite_items) {
        if (itm.product_id == this.composite_item.product_id) {
          exist = true;
        }
      }
      if (!exist && this.composite_item.product_id) {
        this.tech_map.composite_items.push(this.$copy(this.composite_item));
      }
      this.composite_item = {
        name: null
      };
    },

    removeItem(item) {
      const items = [];
      for (const it of this.tech_map.composite_items) {
        if (item.product_id == it.product_id) {
          continue;
        }
        items.push(it);
      }
      this.tech_map.composite_items = items;
    }
  },
  mounted() {
    if (this.target == "update") {
      this.getByIdTechMap(true);
    }
  }
};
</script>
